/**
 * A full-page navigation (the router and every store start over). One seam so
 * a test can see where a bounce went: jsdom does not implement navigation, so
 * an assignment to `window.location.href` is invisible to it.
 */
export function hardNavigate(url: string): void {
  window.location.href = url;
}
